export const VERSION_CHECK_INTERVAL = 30000; // 30 seconds

export const SHOW_UPDATE_REMINDER_INTERVAL = 1800000; // 30 minutes
